import { useAuth0 } from "@auth0/auth0-react";
import {
  Avatar,
  Box,
  Flex,
  HStack,
  Menu,
  MenuItem,
  MenuList,
  Text,
  useMenuButton,
  UseMenuButtonProps,
  useToast,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { HiOutlineDownload, HiOutlineLogout } from "react-icons/hi";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";

import { useKy } from "src/common/ky";
import { downloadFile } from "src/common/util";

const UserAvatar = () => <Avatar size="sm" />;

const ProfileMenuButton = (props: UseMenuButtonProps) => {
  const buttonProps = useMenuButton(props);
  return (
    <Flex
      {...buttonProps}
      as="button"
      flexShrink={0}
      rounded="full"
      outline="0"
      _focus={{ shadow: "outline" }}
    >
      <Box srOnly>Open user menu</Box>
      <UserAvatar />
    </Flex>
  );
};

type ProfileDropdownProps = {
  hideNavigation?: boolean;
};
export const ProfileDropdown = ({ hideNavigation }: ProfileDropdownProps) => {
  const { user } = useAuth0();

  const email = user?.email;

  const toast = useToast();
  const ky = useKy();

  const billingReportQuery = useQuery(
    "BILLING_REPORT",
    () => ky.get("billing-report"),
    {
      enabled: false,
      onSuccess: async (response) => {
        const date = format(new Date(), "yyyy-MM-dd");
        await downloadFile(response, `billing-report-${date}.csv`);
        toast({
          description: "Billing Report successfully downloaded",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      },
    }
  );

  return (
    <Menu>
      <ProfileMenuButton />
      <MenuList rounded="md" shadow="lg" py="1" color="gray.600" fontSize="sm">
        <HStack px="3" py="4">
          <UserAvatar />
          <Box lineHeight="1">
            <Text mt="1" fontSize="xs" color="gray.500">
              {email}
            </Text>
          </Box>
        </HStack>
        {!hideNavigation && (
          <MenuItem
            fontWeight="medium"
            justifyContent="space-between"
            onClick={() => billingReportQuery.refetch()}
            isDisabled={billingReportQuery.isFetching}
          >
            Download Billing Report
            <HiOutlineDownload />
          </MenuItem>
        )}
        <MenuItem
          fontWeight="medium"
          color="red.500"
          justifyContent="space-between"
          as={Link}
          to={"/logout"}
        >
          Sign out
          <HiOutlineLogout />
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
